import { useMemo } from 'react';

import AvailabilitiesErrorContainer from 'reservations/availabilities/components/AvailabilitiesErrorContainer';
import { getNoAvailabilitiesMessage } from 'reservations/availabilities/helpers/getNoAvailabilitiesMessage';
import { COMMON_DATETIME_FORMATS } from 'reservations/base/helpers/datetime';

export type NoAvailabilitiesProps = {
  date: Date;
  partySize: number;
  hasFirstAvailableDate: boolean;
  maxAdvanceDays: number;
};

export const NoAvailabilities = ({
  date,
  partySize,
  hasFirstAvailableDate,
  maxAdvanceDays
}: NoAvailabilitiesProps) => {
  const formattedDate = useMemo(
    () => COMMON_DATETIME_FORMATS.dayDateOnly(date),
    [date]
  );
  return (
    <AvailabilitiesErrorContainer
      message={getNoAvailabilitiesMessage({
        partySize,
        hasFirstAvailableDate,
        maxAdvanceDays,
        date: formattedDate
      })}
    />
  );
};
